import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { Dialog } from '../../../components/Dialog';
import { FormGroup } from '../../../components/FormGroup';
import { FormRow } from '../../../components/FormRow';
import { RadioButtons } from '../../../components/RadioButtons';
import { selectNexaReceiver } from '../../../reducers/nexaReceiversSlice';
import { saveNexaReceiver } from '../../../actions/SaveNexaReceiver';
import { parseInteger } from '../../../util/parseInteger';
import { createNexaReceiver } from '../../../actions/CreateNexaReceiver';
import { deleteNexaReceiver } from '../../../actions/DeleteNexaReceiver';
import { unique_value } from '../../../util/unique';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa s\u00E4ndare" }));
const CodeRow = (props) => {
    var _a, _b;
    return (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '6fr 5fr 1fr', paddingTop: '1px' }, children: [_jsx("div", { style: { paddingRight: '15px', paddingBottom: '3px' }, children: _jsx("input", { type: "text", inputMode: "numeric", name: 'code_' + props.index, value: (_a = props.item.code) !== null && _a !== void 0 ? _a : '', onChange: event => props.updateCode(event.target.value) }) }), _jsx("div", { style: { paddingRight: '15px', paddingBottom: '3px' }, children: _jsx("input", { type: "text", inputMode: "numeric", name: 'unit_' + props.index, value: (_b = props.item.unit) !== null && _b !== void 0 ? _b : '', onChange: event => props.updateUnit(event.target.value) }) }), _jsx("div", { children: _jsx("button", { type: "button", className: "close", "aria-label": "Close", style: { paddingTop: '5px' }, onClick: () => props.deleteItem(), children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }) })] }));
};
const CodeRows = (props) => {
    const rows = props.data.map((codeItem, index) => (_jsx(CodeRow, { index: index, item: codeItem, deleteItem: () => props.deleteItem(index), updateCode: (v) => props.updateCode(index, v), updateUnit: (v) => props.updateUnit(index, v) }, codeItem.key)));
    return (_jsxs("div", { children: [_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', paddingTop: '5px' }, children: [_jsx("label", { className: "grouptitle", style: { whiteSpace: 'nowrap' }, children: "Kod" }), _jsx("label", { className: "grouptitle", style: { whiteSpace: 'nowrap' }, children: "Enhet" })] }), rows, _jsx("div", { children: _jsx("button", { className: "lw success add-code", type: "button", "aria-label": "Add", style: { paddingTop: '5px' }, onClick: () => props.addItem(), children: _jsx("span", { "aria-hidden": "true", children: "Add" }) }) })] }));
};
export const DialogNexaReceiverEdit = (props) => {
    const dispatch = useAppDispatch();
    const [title, setTitle] = useState('');
    const [kind, setKind] = useState('onoff');
    const [codes, setCodes] = useState([]);
    const [comment, setComment] = useState('');
    const receiver = useAppSelector(selectNexaReceiver(props.id == 'new' ? undefined : props.id));
    const appendToCodes = () => {
        setCodes([...codes,
            { key: unique_value(),
                code: '',
                unit: '', }]);
    };
    const deleteFromCodes = (index) => {
        setCodes([...codes.slice(0, index), ...codes.slice(index + 1)]);
    };
    const updateCode = (index, value) => {
        setCodes([...codes.slice(0, index), Object.assign(Object.assign({}, codes[index]), { code: value }), ...codes.slice(index + 1)]);
    };
    const updateUnit = (index, value) => {
        setCodes([...codes.slice(0, index), Object.assign(Object.assign({}, codes[index]), { unit: value }), ...codes.slice(index + 1)]);
    };
    const saveHandler = () => {
        if (receiver == undefined) {
            return;
        }
        const validatedCodes = [];
        for (const ec of codes) {
            const codeAsNum = parseInteger(ec.code);
            const unitAsNum = parseInteger(ec.unit);
            if (codeAsNum == undefined || unitAsNum == undefined) {
                return;
            }
            validatedCodes.push({ code: codeAsNum, unit: unitAsNum });
        }
        const t = {
            id: receiver.id,
            title,
            kind,
            codes: validatedCodes,
            comment,
            created: receiver.created
        };
        dispatch(saveNexaReceiver(t, () => props.onClose()));
    };
    const createHandler = () => {
        const validatedCodes = [];
        for (const ec of codes) {
            const codeAsNum = parseInteger(ec.code);
            const unitAsNum = parseInteger(ec.unit);
            if (codeAsNum == undefined || unitAsNum == undefined) {
                return;
            }
            validatedCodes.push({ code: codeAsNum, unit: unitAsNum });
        }
        const t = {
            title,
            kind,
            codes: validatedCodes,
            comment,
        };
        dispatch(createNexaReceiver(t, () => props.onClose()));
    };
    const deleteHandler = () => {
        if (receiver != undefined) {
            dispatch(deleteNexaReceiver(receiver.id, () => props.onClose()));
        }
    };
    useEffect(() => {
        if (receiver == undefined) {
            setTitle('');
            setKind('onoff');
            setCodes([]);
            setComment('');
        }
        else {
            const codes = [];
            for (const c of receiver.codes) {
                codes.push({
                    key: unique_value(),
                    code: c.code.toString(),
                    unit: c.unit.toString(),
                });
            }
            setTitle(receiver.title);
            setKind(receiver.kind);
            setCodes(codes);
            setComment(receiver.comment);
        }
    }, [receiver, props.id, props.isOpen]);
    let footerleft, footerright;
    const radiobuttons = [
        { kind: 'onoff', title: 'På/Av' },
        { kind: 'dimmer', title: 'Dimmer' },
    ];
    if (props.id != 'new') {
        footerleft = (_jsx(DeleteButton, { onClick: () => deleteHandler() }, "delete"));
        footerright = [
            (_jsx(CancelButton, { onClick: () => props.onClose() }, "cancel")),
            (_jsx(SaveButton, { onClick: () => saveHandler() }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => props.onClose() }, "cancel")),
            (_jsx(CreateButton, { onClick: () => createHandler() }, "create"))
        ];
    }
    const dialogTitle = props.id == 'new' ? 'Skapa sändare' : 'Redigera sändare';
    return (_jsxs(Dialog, { title: dialogTitle, isOpen: props.isOpen, footerleft: footerleft, footerright: footerright, close: props.onClose, children: [_jsx(FormRow, { children: _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: title, onChange: event => setTitle(event.target.value) }) }) }), _jsx(FormRow, { children: _jsx(RadioButtons, { buttons: radiobuttons, name: 'kind', kind: kind, updateKind: (v) => setKind(v) }) }), _jsx(FormRow, { children: _jsx(CodeRows, { data: codes, addItem: () => appendToCodes(), deleteItem: (index) => deleteFromCodes(index), updateCode: updateCode, updateUnit: updateUnit }) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Kommentar", children: _jsx("input", { type: "text", name: "comment", value: comment, onChange: event => setComment(event.target.value) }) }) }), _jsx("input", { name: "receiver_id", type: "hidden", value: props.id })] }));
};
